import React from 'react';

//UI
import { Button, Grid, Typography, Field } from '@l_ine/core';

//REDUX
import { connect } from 'react-redux';
import AuthActions from '../../../redux/auth/actions';
import AppActions from '../../../redux/app/actions';

//NEXT
import Router from 'next/router';
import { composeValidators, required, email } from '../../../utils/rules';
import LoginLayout from '../../../components/LoginLayout';
import { randomString } from '../../../utils/AllUtils';
const logo_icfc = '../../../../static/images/logo_icfc.png';

function Email(props: any) {
  const onSubmit = async (values: any) => {
    if (values) {
      let aux = {
        ...values,
        url: Router.query && Router.query.url ? Router.query.url : null,
        icon: Router.query && Router.query.icon ? Router.query.icon : null,
      };
      props.forgotPassword(aux);
    }
  };

  return (
    <LoginLayout
      onSubmit={onSubmit}
      form={
        <form onSubmit={() => {}} noValidate>
          <Grid container justifyContent='center' spacing={3}>
            <Grid item xs={12} style={{ textAlign: 'center' }}>
              <Typography variant='titleLG'>Esqueceu a senha?</Typography>
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'center', paddingBottom: 32 }}>
              <Typography variant='bodySM'>
                Informe seu e-mail e enviaremos as instruções de como alterar sua
                senha
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Field
                inputProps={{
                  autocomplete: randomString(),
                  'data-testid': 'forgotPasswordEmail--field-email',
                }}
                label='E-mail'
                name='email'
                required
                fieldsize='md'
                validate={composeValidators(required, email)}
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                data-testid='forgotPasswordEmail--button-enviarEmail'
                size='lg'
                fullWidth
                type='submit'
              >
                Enviar e-mail
              </Button>
              <Button
                data-testid='forgotPasswordEmail--button-voltarParaTelaDeLogin'
                type='button'
                variant='neutral'
                fullWidth
                size='lg'
                style={{ marginTop: 8 }}
                onClick={() => {
                  if (Router.query.url) {
                    Router.push(
                      `/signin?icon=${
                        Router.query && Router.query.icon
                          ? Router.query.icon
                          : logo_icfc
                      }&url=${
                        Router.query && Router.query.url ? Router.query.url : null
                      }`
                    );
                  } else {
                    Router.push('/signin');
                  }
                }}
              >
                Voltar para tela de login
              </Button>
            </Grid>
          </Grid>
        </form>
      }
    />
  );
}

const { forgotPassword } = AuthActions;
const { toggleSnackBar } = AppActions;

export default connect(null, { forgotPassword, toggleSnackBar })(Email);
